
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const WelcomePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col justify-between p-6">
      <div className="flex-1 flex flex-col items-center justify-center text-center max-w-md mx-auto space-y-6">
        {/* Logo and title */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="space-y-2"
        >
          <div className="h-24 w-24 bg-lime rounded-full flex items-center justify-center mb-4 mx-auto">
            <span className="text-3xl font-bold">🚗</span>
          </div>
          <h1 className="text-3xl font-bold">Welcome to On Wheels</h1>
          <p className="text-xl font-medium text-lime">your car's smart companion</p>
        </motion.div>

        {/* Intro text */}
        <motion.p 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.5 }}
          className="text-muted-foreground"
        >
          Log issues, track repairs, and get smart help — all in one place.
        </motion.p>
      </div>

      {/* Button */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.5 }}
        className="w-full max-w-md mx-auto"
      >
        <Button 
          onClick={() => navigate('/onboarding/signup')} 
          className="w-full bg-lime text-black hover:bg-lime/90 py-6 rounded-xl"
          size="lg"
        >
          Get Started
          <ArrowRight className="ml-2" />
        </Button>
      </motion.div>
    </div>
  );
};

export default WelcomePage;
